import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const VIDEO_SRC = '/videos/founder-welcome.mp4';
const CAPTIONS_SRC = '/videos/founder-welcome.en.vtt';

/**
 * The founder's portrait doubles as the cover of his one-minute welcome video.
 * Nothing plays until the visitor asks: pressing the portrait opens the video in
 * a dialog, with sound, controls and switchable English subtitles.
 */
const FounderWelcomeVideo = ({ posterSrc, alt }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group relative block w-full h-full text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-[#dca200]"
        aria-label="Watch a one-minute welcome from Col Rakesh Dogra (Retd)"
      >
        <img src={posterSrc} alt={alt} className="w-full h-full object-cover" draggable={false} />
        <span className="absolute inset-0 bg-gradient-to-t from-[#0c1323]/70 via-transparent to-transparent" />
        <span className="absolute inset-x-0 bottom-0 flex items-center gap-3 p-5">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#fff9ea]/95 shadow-lg transition-transform duration-200 group-hover:scale-105">
            <Play className="h-5 w-5 translate-x-[1px] text-[#152c4f]" fill="currentColor" />
          </span>
          <span className="text-base font-medium text-white">A one-minute welcome</span>
        </span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-[min(92vw,calc(86vh*9/16))] max-w-none gap-0 overflow-hidden border-0 bg-black p-0 sm:rounded-2xl [&>button]:text-white [&>button]:opacity-90">
          <DialogTitle className="sr-only">A welcome from our founder</DialogTitle>
          <DialogDescription className="sr-only">
            Col Rakesh Dogra (Retd), Founder of SoulSathiya, on a more thoughtful way of finding a life partner.
          </DialogDescription>
          {open ? (
            <video
              className="block aspect-[9/16] w-full bg-black"
              src={VIDEO_SRC}
              poster={posterSrc}
              controls
              autoPlay
              playsInline
              preload="metadata"
            >
              <track kind="captions" src={CAPTIONS_SRC} srcLang="en" label="English" />
            </video>
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FounderWelcomeVideo;
